import { TransactionMaterial } from "./materials";
import { NoteRecord } from "./notes";

export enum TransactionType {
  Pickup = "Pickup",
  Shipment = "Shipment",
  Delivery = "Delivery",
  Receipt = "Receipt",
  Disposition = "Disposition",
  Adjustment = "Adjustment",
  Retreading = "Retreading",
}

export enum TransactionStatus {
  Submitted = "Submitted",
  InReview = "Reviewing",
  Suspended = "Suspended",
  Reviewed = "Reviewed",
  Approved = "Approved",
  Invalid = "Invalid",
  Invoiced = "Invoiced",
  Synchronizing = "Synchronizing",
  Initiated = "Initiated",
}

export interface LinkedTransaction {
  transactionType: TransactionType;
  transactionNumber: string;
  transactionStatus: TransactionStatus;
}

export interface GridTransaction {
  transactionId: number;
  transactionNumber: string;
  completedDate: string;
  transactionType: TransactionType;
  statusCode: TransactionStatus;
  sourceParticipantRegNumber?: number;
  sourceParticipantDisplayName?: string;
  targetParticipantRegNumber: number;
  targetParticipantDisplayName: string;
  isCorrected: boolean;
  isAdjustable: boolean;
  isValidating: boolean;
  isPaperForm: boolean;
  isInvoiceable: boolean;
  linkedTransactions: LinkedTransaction[];
  invoiceNumber?: string;
  claimNumber?: string;
  trailerNumber?: string;
}

export interface GridTransactionExport extends GridTransaction {
  syncedDate?: string;
  initiatedDate?: string;
  materials: TransactionMaterial[];
  grossWeight: number;
  tareWeight: number;
  netWeight: number;
  estimatedWeight: number;
  weightVariancePercentage?: number;
  targetSignerDisplayName?: string;
  sourceSignerDisplayName?: string;
  scaleTicketNumbers: string[];
  assigneeDisplayName?: string;
  sourceRoute?: string;
  scaleTicketDates: string[];
  sourceParticipantBusinessRoleCode: string;
  targetParticipantBusinessRoleCode: string;
  invoiceNumber?: string;
  invoiceDate?: string;
  paymentAmount?: string;
  dispositionInvoiceNumber?: string;
  dispositionInvoiceDate?: string;
  historyLogs?: NoteRecord[];
  notes?: NoteRecord[];
  isEdited: boolean;
  sortYardId: number;
  productionReportDate?: string;
  retreadingPeriodDate?: string;
  recoveryGain?: string;
  retreadingType?: string;
}

export interface GridTransactionList<T extends GridTransaction> {
  total: number;
  transactions: T[];
}

export interface DataGridFiltersParams {
  propertyName: string;
  values: string;
}

export interface DataGridOptionsParams {
  isAscending: boolean;
  propertyName: string;
}

export interface DataGridRequestParams {
  sortingBy: DataGridOptionsParams;
  filteringParameters: DataGridFiltersParams[];
}

export interface RowInvoice {
  name: string;
  value: string | number;
  additionalValue?: string | number;
  isTitle?: boolean;
  withBorder?: boolean;
  withBoldBorder?: boolean;
  isTotal?: boolean;
  isGrandTotal?: boolean;
}
